import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t border-zinc-900 text-zinc-400">
      <div className="container py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div className="md:col-span-1">
            <h3 className="mb-3 text-base font-medium text-white">Upside Down Capital</h3>
            <address className="not-italic text-sm leading-relaxed text-zinc-500">
              86-90 Paul Street<br />
              London<br />
              EC2A 4NE
            </address>
            <a
              href="mailto:hello@udcapital.uk"
              className="mt-3 inline-block text-sm text-zinc-400 transition-colors hover:text-white"
            >
              hello@udcapital.uk
            </a>
          </div>

          <div>
            <h4 className="mb-3 text-xs font-medium uppercase tracking-[0.18em] text-zinc-600">
              Company
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="transition-colors hover:text-white">About</Link>
              </li>
              <li>
                <Link to="/contact" className="transition-colors hover:text-white">Contact</Link>
              </li>
              <li>
                <Link to="/signup-request" className="transition-colors hover:text-white">
                  Request Access
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-xs font-medium uppercase tracking-[0.18em] text-zinc-600">
              Legal
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/terms" className="transition-colors hover:text-white">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="transition-colors hover:text-white">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-zinc-900 pt-6 text-xs text-zinc-600">
          <p>&copy; {new Date().getFullYear()} Upside Down Capital. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
